import script from "./OrganizationListing.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationListing.vue?vue&type=script&lang=ts&setup=true"

import "./OrganizationListing.vue?vue&type=style&index=0&id=049b7762&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049b7762"]])

export default __exports__